<template>
   <div>
      <v-container>
         <v-dialog
            v-model="adminmodal"
            persistent
            width="550px"
            height="500px"
            @keydown.esc="cancel"
         >
            <v-sheet>
               <v-row no-gutters class="d-flex pa-0">
                  <v-col cols="12">
                     <v-toolbar dense :class="$globalstore.toolbar_headerclass">
                        <v-toolbar-title v-if="$vuetify.breakpoint.mdAndUp">
                           Group Administrators
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn @click.native="cancelBtnClick" class="mx-2">Cancel</v-btn>
                        <v-btn @click.native="OkBtnClick" class="mx-2">OK</v-btn>
                     </v-toolbar>
                     <v-card class="overflow-y-auto">
                        <v-card-title>
                           <v-text-field
                              v-model="table_search"
                              append-icon="mdi-magnify"
                              label="Search"
                              single-line
                              hide-details
                           ></v-text-field>
                        </v-card-title>
                        <v-data-table
                           dense
                           fixed-header
                           height="50vh"
                           v-model="selectedadmin"
                           :headers="data_headers"
                           :items="adminlist"
                           @click:row="rowClick"
                           item-key="id"
                           :search="table_search"
                           :single-select="!multiselect"
                           :show-select="multiselect"
                        >
                        </v-data-table>
                     </v-card>
                  </v-col>
               </v-row>
            </v-sheet>
         </v-dialog>
      </v-container>
   </div>
</template>

<script>
   export default {
      props: {
         admindata: Array,
         dialogvisible: Boolean,
         multiselect: Boolean,
      },
      data() {
         return {
            resolve: null,
            reject: null,
            adminlist: [],
            selectedadmin: [],
            adminmodal: false,
            table_search: "",

            data_headers: [
               {
                  text: "Name",
                  align: "start",
                  value: "username",
                  width: "45%",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Type",
                  value: "usertypetext",
                  width: "20%",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Role",
                  value: "userroles",
                  width: "35%",
                  class: this.$globalstore.table_headerclass,
               },
            ],
         };
      },
      watch: {
         dialogvisible: function(newval, oldval) {
            if (newval) {
               this.loadAdminList();
               this.table_search = "";
               this.selectedadmin = [];
               this.adminmodal = true;
            } else {
               this.adminmodal = false;
            }
         },
      },
      methods: {
         async loadAdminList() {
            await this.$http({
               url: "/cca/adminlist.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (!response.data.error) {
                  this.adminlist = response.data.admindata.filter((item) => {
                     return !this.admindata.some((x) => x.id == item.id);
                  });
               } else {
                  this.adminlist = [];
               }
            });
         },

         OkBtnClick() {
            this.adminmodal = false;
            if (this.selectedadmin.length > 0) {
               this.$emit("save-selection", this.selectedadmin);
            } else {
               this.$emit("cancel-selection");
            }
         },
         cancelBtnClick() {
            this.adminmodal = false;
            this.$emit("cancel-selection");
         },
         rowClick(admindata, row) {
            row.select(row.isSelected);
         },
      },

      mounted() {
         this.table_search = "";
         this.selectedadmin = [];
      },
   };
</script>
